import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { defaultRouteForRole } from './Login';

interface Props {
  children: ReactNode;
  roles?: Array<'super_admin' | 'operator_admin' | 'dispatcher' | 'employee'>;
}

export function Protected({ children, roles }: Props) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="auth-page">Lädt…</div>;
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (user.must_reset_pw && location.pathname !== '/setup-password') {
    return <Navigate to="/setup-password" replace />;
  }
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={defaultRouteForRole(user.role)} replace />;
  }
  return <>{children}</>;
}
